import Vue from 'vue';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, min, max, email, confirmed, alpha, alpha_dash, alpha_spaces, integer } from 'vee-validate/dist/rules';

Vue.component('Validate', ValidationProvider);
Vue.component('Observe', ValidationObserver);

class Validator {
  constructor() {
    const regex = RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/),
      currencyRegex = RegExp(/^\d+\.?\d{0,2}?$/),
      floatRegex = RegExp(/(\d*[.])?\d+$/),
      hexReg = RegExp(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)

    extend('email', {
      ...email,
      message: '{_field_} must be a valid email address.',
    });

    extend('required', {
      ...required,
      message: '{_field_} is required.',
    });

    extend('min', {
      ...min,
      message: '{_field_} must have at least {length} characters.',
    });

    extend('max', {
      ...max,
      message: '{_field_} cannot have more than {length} characters.',
    });

    extend('confirmed', {
      ...confirmed,
      message: '{_field_} must match confirmation.',
    });

    extend('alpha', {
      ...alpha,
      message: '{_field_} can only have letters.'
    });

    extend('alpha_dash', {
      ...alpha_dash,
      message: '{_field_} can only have letters, numbers or dashes.'
    });

    extend('alpha_spaces', {
      ...alpha_spaces,
      message: '{_field_} can only have letters or spaces.'
    });

    extend('integer', {
      ...integer,
      message: '{_field_} can only have numbers.'
    });

    extend('currency', value => {
      if(currencyRegex.test(value)) {
        return true;
      }

      return '{_field_} must be in currency format 0.00.';
    });

    extend('url', value => {
      if (regex.test(value)) {
        return true;
      }

      return '{_field_} must be a valid URL.';
    });

    extend('float', value => {
      if (floatRegex.test(value)) {
        return true;
      }

      return '{_field_} can only have numbers.';
    });

    extend('hex', value => {
      if (hexReg.test(value)) {
        return true;
      }

      return '{_field_} must be a valid hex color.';
    });
  }
};

export default new Validator();